// app/javascript/controllers/crud/ctps_digital_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    targetCtps: String,
    targetSerie: String,
    targetUpload: String,
  };

  connect() {
    this.toggle();
  }

  toggle() {
    const checked = this.isChecked();
    const ctps = this.resolve(this.targetCtpsValue);
    const serie = this.resolve(this.targetSerieValue);
    const uploadWrapper = this.targetUploadValue
      ? document.querySelector(this.targetUploadValue)
      : null;

    if (checked) {
      // CTPS Digital: nao precisa de numero, serie nem anexo fisico
      if (ctps) {
        this.disableField(ctps);
        this.setRequired(ctps, false);
        ctps.value = "";
      }
      if (serie) {
        this.disableField(serie);
        this.setRequired(serie, false);
        serie.value = "";
      }

      // esconde o wrapper do upload e remove required do file input
      if (uploadWrapper) {
        uploadWrapper.style.display = "none";
        const fileInput = uploadWrapper.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.required = false;
          fileInput.removeAttribute("aria-required");
        }
      }
    } else {
      // CTPS fisica: obriga numero, serie e anexo
      if (ctps) {
        this.enableField(ctps);
        this.setRequired(ctps, true);
      }
      if (serie) {
        this.enableField(serie);
        this.setRequired(serie, true);
      }

      // mostra o wrapper do upload e re-adiciona required (somente se nao tem anexo existente)
      if (uploadWrapper) {
        uploadWrapper.style.display = "";
        const fileInput = uploadWrapper.querySelector('input[type="file"]');
        if (fileInput) {
          const hasExistingAttachment = !!uploadWrapper.querySelector('a[target="_blank"]');
          if (!hasExistingAttachment) {
            fileInput.required = true;
            fileInput.setAttribute("aria-required", "true");
          }
        }
      }
    }
  }

  isChecked() {
    const el = this.element;
    if (el && el.type === "checkbox") return !!el.checked;

    const input = this.element.querySelector('input[type="checkbox"]');
    return input ? !!input.checked : false;
  }

  resolve(selector) {
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (_e) {
      return null;
    }
  }

  disableField(input) {
    input.disabled = true;
    input.classList.add("bg-gray-100", "text-gray-500", "cursor-not-allowed");

    const wrapper = input.closest(".input");
    if (wrapper) wrapper.classList.add("opacity-80");
  }

  enableField(input) {
    input.disabled = false;
    input.classList.remove("bg-gray-100", "text-gray-500", "cursor-not-allowed");

    const wrapper = input.closest(".input");
    if (wrapper) wrapper.classList.remove("opacity-80");
  }

  setRequired(input, required) {
    if (input.dataset.originalRequired == null) {
      input.dataset.originalRequired = input.required ? "1" : "0";
    }

    if (required) {
      input.required = true;
      input.setAttribute("aria-required", "true");
    } else {
      input.required = false;
      input.removeAttribute("aria-required");
    }

    const wrapper = input.closest(".input");
    if (wrapper) {
      const abbr = wrapper.querySelector("label abbr[title]");
      if (abbr) abbr.style.display = required ? "" : "none";
    }
  }
}
